import React from 'react';
import ActionButton from '../../ActionButton';
import { Grid, Typography } from '@mui/material';
import { TranslationKeys } from '../../../translations';
import { FormattedMessage } from 'react-intl';

type FileUploadIconProps = {
  onlyExcel?: boolean;
  onlyXml?: boolean;
  onlyCsv?: boolean;
  disabled?: boolean;
};

export const FileUploadIcon = ({
  disabled = false,
  onlyExcel = false,
  onlyXml = false,
  onlyCsv = false,
}: FileUploadIconProps) => {
  const messageId = React.useMemo(() => {
    if (onlyExcel) {
      return TranslationKeys.upload_fileTypesOnlyExcel;
    }
    if (onlyXml) {
      return TranslationKeys.upload_fileTypesOnlyXml;
    }
    if (onlyCsv) {
      return TranslationKeys.upload_fileTypesOnlyCsv;
    }

    return TranslationKeys.upload_fileTypes;
  }, [onlyExcel, onlyXml, onlyCsv]);

  return (
    <Grid container spacing={2} sx={{ display: 'flex', justifyContent: 'center' }}>
      <Grid item xs={12}>
        <ActionButton messageId={TranslationKeys.button_upload} variant={'outlined'} disabled={disabled} />
      </Grid>
      <Grid item xs={12}>
        <Typography variant={'caption'}>
          <FormattedMessage id={messageId} />
        </Typography>
      </Grid>
    </Grid>
  );
};
